import React from "react";
import UnifiedServicePage from "../components/CommonSections/UnifiedServicePage";

export default function ManagedDdosProtection() {
     return (
          <UnifiedServicePage
               serviceTag="managed_ddos_protection"
               pageName="managed-ddos-protection"
               pageUrl="https://ishantechnologies.com/managed-ddos-protection"
               parentTitle="Cybersecurity Services"
               parentUrl="https://ishantechnologies.com/cybersecurity-services"
               infoImageAlt="Managed DDoS Protection"
          />
     );
}
